export const ErrorsPinRestore: Record<string, string> = {
  IDENTITY_VERIFICATION_EXPIRED:
    'La verificación venció. Vuelve a verificar tu identidad',
};
